<template>
  <v-switch
    v-model="status_switch"
    hide-details
    class="mt-4 mb-2"
    inset
    label="Utilizar Estoque Atual"
    @change="aplicarStatusDoEstoque()"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import Api from '@/api/api';

export default {
  data: () => ({
    status_switch: false
  }),
  computed: {
    ...mapGetters({
      GET_FORM_NOVO_EVENTO: 'EventoSazonalFinal/GET_FORM_NOVO_EVENTO',
      GET_DIALOG_CONFIGURACAO_GERAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_GERAL',
      GET_DIALOG_CONFIGURACAO_INDIVIDUAL: 'EventoSazonalFinal/GET_DIALOG_CONFIGURACAO_INDIVIDUAL',
    })
  },
  mounted() {
    this.buscarStatusDoEstoque();
  },
  watch: {
    GET_DIALOG_CONFIGURACAO_GERAL(valor) {
      if (valor) this.buscarStatusDoEstoque();
    },
    GET_DIALOG_CONFIGURACAO_INDIVIDUAL(valor) {
      if (valor) this.buscarStatusDoEstoque();
    }
  },
  methods: {
    buscarStatusDoEstoque() {
      Api.post(`eventos-sazonais/parametrizacao/configuracao/utilizar-estoque-atual`, this.GET_FORM_NOVO_EVENTO)
        .then(response => this.status_switch = response.data.utilizar_estoque)
        .catch(this.Helpers.logout);
    },
    aplicarStatusDoEstoque() {
      const params = {
        status: this.status_switch,
        evento: this.GET_FORM_NOVO_EVENTO
      }

      Api.post(`eventos-sazonais/parametrizacao/configuracao/aplicar-estoque-atual`, params).catch(this.Helpers.logout);
    }
  }
}
</script>

<style>

</style>
